import React from 'react';

import styles from './RightPanel.module.css';
import RightPanelItem from './RightPanelItem';

function RightPanelGroup({ data }) {
    if (!data) {
        return null;
    }

    return (
        data.map((element) => (
            <div key={element.key}>
                {element.title && <h3 className={element.titleStyle || 'mt-6 text-shadeStoneGray font-bold'}>{element.title}</h3>}
                <div className={styles.homeTodoLinkList}>
                    {
                        element.items
                        && element.items.length
                        && element.items.map(
                            (item) => <RightPanelItem key={item.key} data={item} />,
                        )
                    }
                </div>
            </div>
        ))
    );
}

export default RightPanelGroup;
